/* eslint-disable no-bitwise -- a hash and a random number source work on bits */
/** A 32-bit hash of a text (FNV-1a). Pure. */
export function hashText(text: string): number {
  let hash = 0x811c9dc5;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

/**
 * A random number source with a seed (mulberry32): the same seed gives the same numbers in 0..1.
 * The effects use it, so the screen and the exported file show the same circles and the same grain.
 */
export function seededRandom(seed: string | number): () => number {
  let state = typeof seed === 'number' ? seed >>> 0 : hashText(seed);
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let value = state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}
